// extracted by mini-css-extract-plugin
export default {"GoldTogglerBtn":"MainNavbar_GoldTogglerBtn__m-E-x","GoldTogglerIcon":"MainNavbar_GoldTogglerIcon__2oH9x"};